import React from 'react';
import PdfPage from './PdfPage';

function hasFinalConsonant(str) {
  if (!str) return false;
  const code = str.charCodeAt(str.length - 1);
  if (code < 0xAC00 || code > 0xD7A3) return false;
  return (code - 0xAC00) % 28 !== 0;
}

function PdfContact({ data, officeName, dateLabel }) {
  const { office, person } = data;

  return (
    <PdfPage officeName={officeName} pageLabel="— Contact" dateLabel={dateLabel}>
      <div className="p99__body">
        <div className="p99__hero">
          <div className="p99__chapter">Closing</div>
          <h2 className="p99__headline">
            진심을 담은<br />
            <em>매물 보고서</em><br />
            입니다.
          </h2>
          <p className="p99__lede">
            본 보고서는 {officeName}{hasFinalConsonant(officeName) ? '이' : '가'}<br />
            직접 검토 · 정리한 자료입니다.<br />
            추가 자료 · 현장 방문, 협의가 필요하신 경우<br />
            담당자에게 언제든 연락 주십시오.
          </p>
          <div className="p99__sign">— {officeName}</div>
        </div>

        <div className="p99__info">
          <div className="p99__group">
            <div className="p99__group-label">— Company</div>
            <dl className="p99__rows">
              {office.map((row, i) => (
                <React.Fragment key={i}>
                  <dt>{row.label}</dt>
                  <dd className={row.inputType === 'tel' ? 'num' : ''}>{row.value}</dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
          <div className="p99__group">
            <div className="p99__group-label">— In charge</div>
            <dl className="p99__rows">
              {person.map((row, i) => (
                <React.Fragment key={i}>
                  <dt>{row.label}</dt>
                  <dd className={row.inputType === 'tel' ? 'num' : ''}>{row.value}</dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </PdfPage>
  );
}

export default PdfContact;
